/* esm.sh - applesauce-core@5.2.0/observable/defined */
export * from "/*applesauce-core@5.2.0/esnext/observable/defined.mjs";
